import { render, staticRenderFns } from "./TabLayout.vue?vue&type=template&id=2fc1f699&"
import script from "./TabLayout.vue?vue&type=script&lang=js&"
export * from "./TabLayout.vue?vue&type=script&lang=js&"
import style0 from "./TabLayout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc1f699')) {
      api.createRecord('2fc1f699', component.options)
    } else {
      api.reload('2fc1f699', component.options)
    }
    module.hot.accept("./TabLayout.vue?vue&type=template&id=2fc1f699&", function () {
      api.rerender('2fc1f699', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/TabLayout.vue"
export default component.exports